<template>
  <footer class="fixed bottom-0 left-0 right-0 bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800 py-2" style="z-index: 52">
    <div class="max-w-full px-4">
      <div class="flex items-center justify-between">
        <!-- Zone centrale -->
        <div class="text-sm text-gray-600 dark:text-gray-400 text-center flex-1">
          &copy; {{ currentYear }} K&C Madin Invest - Tous droits réservés
        </div>

        <!-- Zone droite: Mentions légales -->
        <div class="flex-shrink-0 pr-2">
          <button
            @click="$emit('open-legal')"
            class="hover:text-gray-900 dark:hover:text-white transition-colors cursor-pointer relative px-2 py-1 inline-block text-sm text-gray-600 dark:text-gray-400"
          >
            Mentions légales
          </button>
        </div>
      </div>
    </div>
  </footer>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted } from 'vue'
import { useLogger } from '@/utils/logger'
import { APP_VERSION } from '@/config/constants'

export default defineComponent({
  name: 'AppFooter',
  emits: ['open-legal'],
  setup() {
    // Initialisation du logger pour ce composant
    const logger = useLogger('Footer')
    
    // Année courante pour le copyright
    const currentYear = ref(new Date().getFullYear())
    
    // Version de l'application
    const appVersion = APP_VERSION
    
    // Version affichée (sans le "v" au début si présent)
    const displayVersion = computed(() => {
      return appVersion.replace(/^v/i, '')
    })
    
    // Exécuté au montage du composant
    onMounted(() => {
      logger.debug('Footer component mounted')
    })
    
    return {
      currentYear,
      appVersion,
      displayVersion,
      
    }
  }
})
</script>
